export function newsletterStatus(user) {
  return (
    user?.newsletter_subscription?.newsletter_subscription_status?.identifier ||
    null
  )
}

export function canOfferNewsletter(user) {
  return !user || newsletterStatus(user) === 'disabled'
}

export function subscriptionAwaitsConfirmation(response) {
  return response?.newsletter_subscription_status === 'pending'
}

export function newsletterSignupEvent({ status, source, language, eventId }) {
  return {
    event: 'newsletter_signup',
    event_id: eventId,
    newsletter_status: status,
    newsletter_source: source,
    ...(language ? { language } : {}),
  }
}

export function newsletterConfirmedEvent({ language, eventId }) {
  return {
    event: 'newsletter_confirmed',
    event_id: eventId,
    ...(language ? { language } : {}),
  }
}
